"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hyperLinkSize = exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _RichTextBold = _interopRequireDefault(require("./RichTextBold"));
var _hyperlinkStyles = require("./hyperlinkStyles");
var _RichTextPropTypes = require("./RichTextPropTypes");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var hyperLinkSize = exports.hyperLinkSize = ['micro', 'small', 'large'];
var RichTextHyperlink = _ref => {
  var {
    href,
    children,
    alternative = false,
    inverse = false,
    target = '_blank'
  } = _ref;
  if (!children) return null;
  var HyperlinkStyle = {
    fontFamily: 'inherit',
    fontSize: 'inherit',
    lineHeight: 'inherit',
    hyperlinkColour: (0, _hyperlinkStyles.getColour)(inverse, alternative)
  };
  return /*#__PURE__*/_react.default.createElement("a", {
    href: href,
    style: {
      color: HyperlinkStyle.hyperlinkColour,
      fontFamily: HyperlinkStyle.fontFamily,
      fontSize: HyperlinkStyle.fontSize,
      lineHeight: HyperlinkStyle.lineHeight
    },
    target: target
  }, _react.default.Children.map(children, child => {
    if (!child) return null;
    return /*#__PURE__*/_react.default.isValidElement(child) && child.type === _RichTextBold.default ? child.props.children : child;
  }));
};
RichTextHyperlink.propTypes = {
  href: _propTypes.default.string,
  children: _propTypes.default.node,
  size: _propTypes.default.oneOf([...hyperLinkSize, ..._RichTextPropTypes.headingSizes, 'medium']),
  alternative: _propTypes.default.bool,
  inverse: _propTypes.default.bool,
  target: _propTypes.default.oneOf(_RichTextPropTypes.linkTargetOptions)
};
var _default = exports.default = RichTextHyperlink;